import { Box, Typography, Button, Card, CardContent } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../redux/authConfig";
import FlowerIcon from "../assets/flower.svg";
import GirlIcon from "../assets/girl.svg";
import LoginIcon from "../assets/loginIcon.svg";
import LucyLogo from "../assets/lucyLogo.svg";
export default function LoginPage() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect({ ...loginRequest, prompt: "login" });
  };
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh", // allow content to extend if needed
        width: "100vw",
        // Prevent vertical cropping on small screens while keeping horizontal overflow hidden
        overflowX: "hidden",
        overflowY: { xs: "auto", md: "hidden" },
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      {/* Left Section */}
      <Box
        sx={{
          flex: { xs: "1 1 100%", md: "1 1 50%" },
          background: "#403C6F",
          color: "white",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start", // 🔽 stack from top
          position: "relative",
          minWidth: 0,
          py: 4,
        }}
      >
        {/* Gradient Ellipse */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "510px",
            right: 0,
            marginTop: "-270px",
            background:
              "linear-gradient(1.86deg, rgba(237, 242, 247, 0) 1.56%, rgba(247, 250, 252, 0.4) 188.7%)",
            borderBottomLeftRadius: "100%",
            borderBottomRightRadius: "100%",
            opacity: 1,
            zIndex: 1,
          }}
        />

        {/* Flower-like SVG (attached to top) */}
        <Box
          sx={{
            backgroundImage: `url(${FlowerIcon})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            width: "470px",
            height: "192px",
            opacity: 1,
            position: "absolute", // 🔽 fix to top
            top: 0,
            left: "50%",
            transform: "translateX(-50%)", // center horizontally
            zIndex: 2,
          }}
        />

        {/* LucyRx Text */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            zIndex: 2,
            mt: 13,
          }}
        >
          <Typography
            variant="h3"
            sx={{ fontFamily: "cursive", fontWeight: "bold", mb: 3 }}
          >
            <img src={LucyLogo} alt="LucyRx" style={{ marginBottom: "8px" }} />
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textAlign: "center",
              fontFamily: "Literata",
              fontSize: "19px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "41px",
              width: "80%",
              marginTop: "0px",
              marginBottom: "4px",
            }}
          >
            Want scale, consistency, and measurable impact in patient care? Say
            Halo, Lucy!
          </Typography>
        </Box>

        {/* Girl SVG */}
        <Box
          sx={{
            width: 370,
            height: 340,
            zIndex: 2,
            marginTop: "20px",
            objectFit: "contain",
            // Further responsive adjustments: scale down sooner and ensure full visibility
            "@media (max-width:900px)": {
              width: 320,
              height: 300,
            },
            "@media (max-height:750px)": {
              width: 300,
              height: 280,
            },
            "@media (max-height:650px)": {
              width: 250,
              height: 230,
            },
            "@media (max-height:550px)": {
              width: 200,
              height: 180,
            },
            "@media (max-height:480px)": {
              width: 160,
              height: 150,
            },
            backgroundImage: `url(${GirlIcon})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition: "center",
          }}
        />
      </Box>

      {/* Right Section */}
      <Box
        sx={{
          flex: { xs: "1 1 100%", md: "1 1 50%" },
          backgroundColor: "#ecedf2",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh", // ADD
          justifyContent: "space-between", // ADD
        }}
      >
        {/* main content center */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: { xs: 2, md: 20 },
          }}
        >
          <Card
            sx={{
              borderRadius: 3,
              boxShadow: 3,
              width: "90% !important",
              padding: "40px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CardContent sx={{ textAlign: "center" }}>
              <Typography
                variant="h6"
                sx={{
                  fontSize: "20px",
                  fontWeight: 700,
                  lineHeight: "32px",
                  textAlign: "center",
                }}
              >
                Welcome to Halo
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#405261",
                  fontFamily:
                    "Inter, ui-sans-serif, system-ui, sans-serif !important",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "24px",
                  marginTop: "8px",
                  textAlign: "center",
                }}
              >
                Please sign-in to your account
              </Typography>

              <Button
                fullWidth
                variant="contained"
                startIcon={
                  <img
                    src={LoginIcon}
                    alt="Login"
                    style={{
                      width: "40px",
                      height: "40px",
                      marginRight: "8px",
                    }}
                  />
                }
                onClick={handleLogin} // ✅ trigger Microsoft login
                sx={{
                  backgroundColor: "#403C6F",
                  alignItems: "center",
                  alignSelf: "stretch",
                  borderRadius: "52px",
                  cursor: "pointer",
                  display: "flex",
                  height: "56px",
                  justifyContent: "space-between",
                  marginBottom: "32px",
                  marginTop: "36px",
                  padding: "0 24px 0 13px",
                  fontFamily:
                    "Inter, ui-sans-serif, system-ui, sans-serif !important",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  letterSpacing: ".08px",
                  lineHeight: "24px",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  "&:hover": {
                    backgroundColor: "#34305A",
                    boxShadow: "none",
                  },
                  boxShadow: "none",
                }}
              >
                Log In with Microsoft
              </Button>
            </CardContent>
          </Card>
        </Box>
        {/* Copyright Footer */}
        <Box
          sx={{
            borderTop: "1px solid #cfceda",
            backgroundColor: "#f9f9fb",
            textAlign: "center",
            p: 2,
          }}
        >
          <Typography variant="body2" sx={{ color: "#6E6D92" }}>
            © {new Date().getFullYear()} LucyRx .All Rights Reserved
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
